import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.session.productName}}", {
  moduleName: "core/components/product-name/index.hbs"
});